document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ signature.js 已加载");
  const input = document.getElementById("signature-input");
  const svg = document.getElementById("signature-svg");

  if (!input || !svg) return;

  input.addEventListener("input", () => {
    const text = input.value.trim();
    svg.innerHTML = ""; // 清空之前的内容

    if (text === "") return;

    // 模拟：用 SVG <text> 渲染
    const textElem = document.createElementNS("http://www.w3.org/2000/svg", "text");
    textElem.setAttribute("x", "20");
    textElem.setAttribute("y", "60");
    textElem.setAttribute("font-size", "40");
    textElem.setAttribute("fill", "black");
    textElem.setAttribute("font-family", "cursive"); // 用手写字体模拟
    textElem.textContent = text;

    svg.appendChild(textElem);
  });
});
